import { Slider } from 'atds-slider/src/slider'
import { CALLBACKS_TYPES } from 'atds-slider/src/sliderCallbacks'
import { LoopedSlider } from 'atds-slider/src/loopedSlider'

export const STANDARD = 'Slider'
export const LOOPED = 'LoopedSlider'

export const Sliders = {
  [STANDARD]: Slider,
  [LOOPED]: LoopedSlider
}

export const SlidersCallbacks = Object.freeze({
  READY: CALLBACKS_TYPES.READY,
  ANIMATION: CALLBACKS_TYPES.ANIMATION,
  CAROUSEL_CHANGED: CALLBACKS_TYPES.CAROUSEL_CHANGED
})
